import { useCallback, useEffect } from 'react';
import http from 'hub-http/clients/apiClient';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import H1 from 'UIComponents/elements/headings/H1';
import H5 from 'UIComponents/elements/headings/H5';
import H7 from 'UIComponents/elements/headings/H7';
import HR from 'UIComponents/elements/HR';
import UIBox from 'UIComponents/layout/UIBox';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIModal from 'UIComponents/dialog/UIModal';
import BrowserUrlDisplay from '../browserUrlDisplay/BrowserUrlDisplay';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const updateCustomDomainSetupNextReminderDate = customDomainSetupNextReminderDate => {
  return http.patch('cms-user-settings', {
    data: {
      customDomainSetupNextReminderDate
    }
  });
};
const BasePostPublishDomainSetupModal = ({
  closeModal,
  publishedContentUrl,
  usageTracker
}) => {
  useEffect(() => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'view',
      screen: 'detail'
    });
  }, [usageTracker]);
  const handleStartCustomDomainSetup = useCallback(() => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'clicked-add-custom-domain-button',
      screen: 'detail'
    });
    window.open(Routes.settings('domains'));
  }, [usageTracker]);
  const handleSnoozeModal = () => {
    const nextReminderDate = I18n.moment().add(1, 'days').valueOf();
    updateCustomDomainSetupNextReminderDate(nextReminderDate).then(() => closeModal()).catch(() => {});
  };
  const handleDismissModal = () => {
    updateCustomDomainSetupNextReminderDate(-1).then(() => closeModal()).catch(() => {});
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "success"
      }), /*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ContentComponents.postPublishDomainSetupModal.mainHeader"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ContentComponents.postPublishDomainSetupModal.mainSubheader"
        })
      }), /*#__PURE__*/_jsx(BrowserUrlDisplay, {
        url: publishedContentUrl
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(UIFlex, {
        className: "p-x-10",
        style: {
          color: EERIE
        },
        align: "end",
        children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(UIBox, {
          shrink: 0,
          className: "p-x-4",
          children: /*#__PURE__*/_jsx(H7, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ContentComponents.postPublishDomainSetupModal.ctaHeader"
            })
          })
        }), /*#__PURE__*/_jsx(HR, {})]
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left p-x-10 m-top-6",
        children: [/*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.ctaSubheader"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.ctaBody"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: handleStartCustomDomainSetup,
          use: "primary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.addDomainButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: handleSnoozeModal,
          use: "secondary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.remindMeTomorrowButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: handleDismissModal,
          use: "secondary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.doNotShowAgainButton"
          })
        })]
      })]
    })]
  });
};
export default BasePostPublishDomainSetupModal;